module.exports = __webpack_public_path__ + "static/media/homeTitle1.6c789b9b.png";